'use client';

import React, { PropsWithChildren, ReactNode } from 'react';
import { cn } from '@/utils/cn';
import { useLanguage } from '../context/language-context-provider';
interface Props extends PropsWithChildren {
  title: string;
  icon: ReactNode;
  className?: string;
  isRevertColors?: boolean;
}
const SectionHeading = ({
  icon,
  title,
  className,
  isRevertColors,
  children
}: Props) => {
  const {
    language
  } = useLanguage();
  const isEn = language === 'en';
  return <div className={cn('relative flex items-center text-white', {
    'text-primary-main': isRevertColors
  }, className)} data-sentry-component="SectionHeading" data-sentry-source-file="section-heading.tsx">
            {children}
            <div className={cn('absolute -right-4 flex items-center justify-center rounded-full bg-white p-0.5 lg:-right-8 lg:p-1', {
      'bg-primary-main': isRevertColors
    })}>
                <div className={cn('flex h-8 w-8 items-center justify-center rounded-full bg-primary-main lg:h-14 lg:w-14 [&_svg]:h-5 [&_svg]:w-5 [&_svg]:lg:h-8 [&_svg]:lg:w-8', {
        'bg-white': isRevertColors
      })}>
                    {icon}
                </div>
            </div>

            <span className={cn('min-w-max bg-primary-main py-1.5 pl-2 pr-7 text-body-16 font-medium lg:py-4 lg:pl-4 lg:pr-11 lg:text-xl lg:leading-8', {
      'border border-solid border-primary-main bg-white': isRevertColors,
      'rounded-s-md lg:rounded-s-lg': isEn,
      'rounded-e-md lg:rounded-e-lg': !isEn
    })}>
                {title}
            </span>
        </div>;
};
export default SectionHeading;